import axios from "axios";
import { getCookie } from "../helperFunctions/cookie";

const baseUrl = `${process.env.REACT_APP_API_IP}/api/v1/families`;
const userUrl = `${process.env.REACT_APP_API_IP}/api/v1/users`;

const randomColor = () => {
  let n = (Math.random() * 0xfffff * 1000000).toString(16);
  return "#" + n.slice(0, 6);
};

export const addUserToFamily = async (token, user, familyCode) => {
  const shortcuts = JSON.parse(
    localStorage.getItem("appearance")
  ).listShortcuts;
  const todoShortcut = shortcuts.filter(
    (shortcut) => shortcut.title === "To Do"
  );
  const color = randomColor();
  const res = await axios.patch(
    baseUrl + "/" + familyCode + "/add",
    {
      userName: user.userName,
      userId: user._id,
      amountOfPoints: 0,
      color,
      todoLink: todoShortcut[0].listId,
    },
    { withCredentials: true, headers: { authorization: "Bearer " + token } }
  );
};

export const createFamily = async (token, user, familyName) => {
  const shortcuts = JSON.parse(
    localStorage.getItem("appearance")
  ).listShortcuts;
  const todoShortcut = shortcuts.filter(
    (shortcut) => shortcut.title === "To Do"
  );
  const color = randomColor();
  const res = await axios.post(
    baseUrl,
    {
      familyName,
      familyCode: user.userName,
      createdBy: user.userName,
      canJoin: "public",
      acceptMembers: [],
      members: [
        {
          userName: user.userName,
          userId: user._id,
          amountOfPoints: 0,
          color,
          todoLink: todoShortcut[0].listId,
        },
      ],
    },
    { withCredentials: true, headers: { authorization: "Bearer " + token } }
  );
  return res.data.family._id;
};

export const updateFamily = async (token, user, updatedFamily) => {
  try {
    const res = await axios.patch(
      baseUrl + "/" + user.familyId,
      updatedFamily,
      {
        headers: { authorization: "Bearer " + token },
      }
    );
    localStorage.setItem("family", JSON.stringify(res.data.family));
  } catch (error) {
    console.log(error.response.data);
  }
};

export const getFamily = async (user) => {
  const jwt = getCookie();
  try {
    const res = await axios.get(baseUrl + "/" + user.familyId, {
      headers: { authorization: "Bearer " + jwt },
    });
    localStorage.setItem("family", JSON.stringify(res.data.family[0]));
    return res.data.family[0].members;
  } catch (error) {
    console.log(error.response.data);
  }
};

export const getFamilyId = async (familyCode) => {
  const res = await axios.get(userUrl + "/familyId/" + familyCode);
  return res.data.familyId;
};
